import strawberry from '../../strawberry.png'

export const Results = () => {
  const gameTime = () => {
    const startTime = Date.parse(localStorage.getItem('startTime') || '');
    const endTime = Date.parse(localStorage.getItem('endTime') || '');
    const seconds = (endTime - startTime) / 1000;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return `${minutes} minute${minutes > 1 ? 's' : ''} and ${remainingSeconds} second${seconds > 1 ? 's' : ''}`
  }

  const totalGuesses = () => {
    const round1Guesses = parseInt(localStorage.getItem('round_guesses_1') || '');
    const round2Guesses = parseInt(localStorage.getItem('round_guesses_2') || '');

    return round1Guesses + round2Guesses;
  }

  return (
    <div className="mx-auto max-w-lg p-4 text-center">
      <h1 className="font-bold text-3xl mb-4 light-pink-text">
        Baby Shower Wordle Results
      </h1>

      <p className="mb-4 font-semibold">
        Don't forget to screenshot or record your results!
      </p>

      <ul>
        <li>
          <p className="text-lg">
            <strong>Total Guesses:</strong> {totalGuesses()}
          </p>
        </li>
        <li>
          <p className="text-lg">
            <strong>Total Time:</strong> {gameTime()}
          </p>
        </li>
      </ul>

      <div className="mt-32">
        <img className="animate-ping mx-auto w-1/2 sm:w-1/3" src={strawberry} alt="" />
        </div>
    </div>
  )
};
